import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Button, Spin, Typography, Progress } from 'antd';
import { MailOutlined, TeamOutlined, SendOutlined, EyeOutlined, ReloadOutlined, RocketOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { embotAPI } from '../../services/api';

const { Text } = Typography;

export default function EMDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const res = await embotAPI.getStats();
      setStats(res.data);
    } catch { /* ignore */ }
    setLoading(false);
  };

  useEffect(() => { fetchStats(); }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>;

  const s = stats || {};

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button icon={<ReloadOutlined />} onClick={fetchStats}>Refresh</Button>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic title="Total Contacts" value={s.total_contacts || 0} prefix={<TeamOutlined style={{ color: '#1890ff' }} />} />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic title="Emails Sent" value={s.total_sent || 0} prefix={<SendOutlined style={{ color: '#52c41a' }} />} />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic title="Delivered" value={s.total_delivered || 0} prefix={<CheckCircleOutlined style={{ color: '#13c2c2' }} />} />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card>
            <Statistic title="Campaigns" value={s.total_campaigns || 0} prefix={<RocketOutlined style={{ color: '#722ed1' }} />} />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} sm={12}>
          <Card title="Delivery Rate">
            <Progress
              type="dashboard"
              percent={s.delivery_rate || 0}
              strokeColor={{ '0%': '#108ee9', '100%': '#52c41a' }}
              format={(pct) => <span style={{ fontSize: 20 }}>{pct}%</span>}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card title="Open Rate">
            <Progress
              type="dashboard"
              percent={s.open_rate || 0}
              strokeColor={{ '0%': '#faad14', '100%': '#eb2f96' }}
              format={(pct) => <span style={{ fontSize: 20 }}>{pct}%</span>}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 16 }} title="Quick Actions">
        <Row gutter={[12, 12]}>
          <Col><Button type="primary" icon={<MailOutlined />} href="#" onClick={() => {}}>Compose Email</Button></Col>
          <Col><Button icon={<TeamOutlined />}>Import Contacts</Button></Col>
          <Col><Button icon={<RocketOutlined />}>New Campaign</Button></Col>
        </Row>
      </Card>
    </div>
  );
}
